import type {
    Level,
    NewsArticle,
    NewsGrammarItem,
    NewsVocabularyItem
} from "../../types/global.js";

/** The Journal's learner-level filtering remains independent of its content source. */
const cefrRank: Record<Level, number> = {
    A1: 1,
    A2: 2,
    B1: 3,
    B2: 4,
    C1: 5,
    C2: 6
};

function isNewsContentVisible(contentLevel: Level | undefined, userLevel: Level): boolean {
    if (!contentLevel) return true;
    return cefrRank[contentLevel] <= cefrRank[userLevel] + 1;
}

interface VisibleNewsLearningContent {
    vocabulary: NewsVocabularyItem[];
    grammar: NewsGrammarItem[];
    hasHiddenGrammar: boolean;
}

function getVisibleNewsLearningContent(article: NewsArticle, userLevel: Level): VisibleNewsLearningContent {
    const vocabulary = (article.content.vocabulary ?? []).filter(item =>
        isNewsContentVisible(item.level, userLevel)
    );
    const allGrammar = article.content.grammar ?? [];
    const grammar = allGrammar.filter(item => isNewsContentVisible(item.level, userLevel));

    return {
        vocabulary,
        grammar,
        hasHiddenGrammar: allGrammar.length > 0 && grammar.length === 0
    };
}

function normalizeNewsId(value: string | null | undefined): string | null {
    return value?.trim() || null;
}

export { getVisibleNewsLearningContent, normalizeNewsId };
export type { VisibleNewsLearningContent };
